import * as types from './actionTypes'

const INITIAL_STATE = JSON.parse(JSON.stringify({
  countries: {
    isLoading: false,
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 50,
    },
    receivedAt: null,
  },
}))

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case types.REQUEST_COUNTRIES:
    case types.RECEIVE_COUNTRIES:
      return {
        ...state,
        countries: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.countries.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    default:
      return state
  }
}
